
import { EmailRecord, EmailStats } from "@/types/email";

/**
 * Calculate email statistics
 */
export const calculateEmailStats = (emails: EmailRecord[]): EmailStats => {
  const sent = emails.filter(email => email.status === "sent").length;
  const draft = emails.filter(email => email.status === "draft").length;
  const totalResponses = emails.filter(e => e.hasResponse).length;
  const positiveResponses = emails.filter(
    e => e.responseNotes?.toLowerCase().includes("positive") || 
         e.responseNotes?.toLowerCase().includes("interested")
  ).length;
  
  return {
    total: emails.length,
    sent,
    draft,
    totalSent: sent,
    totalResponses,
    positiveResponses,
    responseRate: sent > 0 ? (totalResponses / sent) * 100 : 0
  };
};
